export const GET_MY_STORE = 'GET_MY_STORE'
export const SET_STORE = 'SET_STORE'
export const REMOVE_STORE = 'REMOVE_STORE'
export const LOADING_STORE = 'LOADING_STORE'